import { useLoadAllItemsQuery } from '@sequencehq/api'
import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import { HOURS } from '@sequencehq/utils/dates'
import { useMemo } from 'react'

export const useLoadAllProductsAndListPrices = () => {
  const productsInfiniteQuery = useLoadAllItemsQuery(
    dashboardv20240509Client.getProducts,
    {
      limit: 100
    },
    {
      staleTime: 1 * HOURS,
      maxPages: 30
    }
  )

  const listPricesInfiniteQuery = useLoadAllItemsQuery(
    dashboardv20240509Client.getListPrices,
    {
      limit: 100
    },
    {
      staleTime: 1 * HOURS,
      maxPages: 30
    }
  )

  const allProducts =
    productsInfiniteQuery.data?.pages.flatMap(p => p.items) ?? []
  const allListPrices =
    listPricesInfiniteQuery.data?.pages.flatMap(p => p.items) ?? []

  const allProductsAndListPrices = useMemo(() => {
    return allProducts.map(product => ({
      ...product,
      listPrices: allListPrices.filter(
        listPrice => listPrice.productId === product.id
      )
    }))
  }, [allProducts, allListPrices])

  const allProductsAndListPricesDictionary = useMemo(() => {
    return allProductsAndListPrices.reduce(
      (acc, item) => {
        acc[item.id] = item
        return acc
      },
      {} as Record<string, (typeof allProductsAndListPrices)[0]>
    )
  }, [allProductsAndListPrices])

  return {
    isLoading:
      listPricesInfiniteQuery.isLoading || productsInfiniteQuery.isLoading,
    allProductsAndListPrices,
    allProductsAndListPricesDictionary,
    allListPrices,
    allProducts
  }
}
